import { axiosInstance } from '.'
import { OPPORTUNITY_INTEREST_BY_ID_V1, OPPORTUNITY_INTERESTS_V1 } from './endpoints'
import type { OpportunityInterestDetail, OpportunityInterestListItem } from '../lib/types'

export const opportunityInterestServices = {
  listAll: async (): Promise<{
    interests: OpportunityInterestListItem[]
    status: number
  }> => {
    try {
      const response = await axiosInstance.get<OpportunityInterestListItem[]>(
        OPPORTUNITY_INTERESTS_V1,
      )
      return {
        interests: Array.isArray(response.data) ? response.data : [],
        status: response.status,
      }
    } catch (error: any) {
      return {
        interests: [],
        status: error?.response?.status ?? 500,
      }
    }
  },

  getById: async (
    id: string | number,
  ): Promise<{
    interest: OpportunityInterestDetail | null
    status: number
    code?: string
    message?: string
  }> => {
    try {
      const response = await axiosInstance.get<OpportunityInterestDetail>(
        OPPORTUNITY_INTEREST_BY_ID_V1(id),
      )
      return {
        interest: response.data,
        status: response.status,
      }
    } catch (error: any) {
      return {
        interest: null,
        status: error?.response?.status ?? 500,
        code: error?.response?.data?.code,
        message: error?.response?.data?.message,
      }
    }
  },
}
